import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode } from "vue"

const _hoisted_1 = { class: "general-tab" }
const _hoisted_2 = {
  key: 0,
  class: "general-tab__loading"
}
const _hoisted_3 = {
  key: 1,
  class: "general-tab__list"
}
const _hoisted_4 = { class: "general-tab__label" }
const _hoisted_5 = { class: "general-tab__value" }
const _hoisted_6 = {
  key: 0,
  class: "general-tab__empty"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    ($setup.loading)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, "Loading device info…"))
      : (_openBlock(), _createElementBlock("div", _hoisted_3, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.rows, (item) => {
            return (_openBlock(), _createElementBlock("div", {
              key: item.label,
              class: "general-tab__row"
            }, [
              _createElementVNode("span", _hoisted_4, _toDisplayString(item.label) + ":", 1 /* TEXT */),
              _createElementVNode("span", _hoisted_5, _toDisplayString(item.value), 1 /* TEXT */)
            ]))
          }), 128 /* KEYED_FRAGMENT */)),
          ($setup.rows.length === 0)
            ? (_openBlock(), _createElementBlock("div", _hoisted_6, "No device info (unknown platform or not available)."))
            : _createCommentVNode("v-if", true)
        ]))
  ]))
}